import { gql } from "@apollo/client"

export default gql`
    mutation translateText($translateTextInput: TranslateTextInput!) {
        translateText(translateTextInput: $translateTextInput) {
            text
        }
    }
`
